import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import React, { memo } from "react";
import { Font, Link } from "@pochta/ui";

// TODO: добавить лимиты на количество элементов для разных экранов
var FooterMenu = function FooterMenu(_ref) {
  var list = _ref.list;
  return /*#__PURE__*/React.createElement(React.Fragment, null, list === null || list === void 0 ? void 0 : list.map(function (item) {
    return /*#__PURE__*/React.createElement(Link, {
      key: item.link,
      underline: "none",
      color: "inherit",
      href: item.link,
      target: item.openInNewTab ? "_blank" : "_self",
      rel: item.openInNewTab ? "noreferrer" : ""
    }, /*#__PURE__*/React.createElement(Font, {
      size: "s"
    }, item.title));
  }));
};

export default /*#__PURE__*/memo(FooterMenu);